import { render, staticRenderFns } from "./CadastroLayoutExportacao.vue?vue&type=template&id=f836c4c2&scoped=true&"
import script from "./CadastroLayoutExportacao.vue?vue&type=script&lang=js&"
export * from "./CadastroLayoutExportacao.vue?vue&type=script&lang=js&"
import style0 from "./CadastroLayoutExportacao.vue?vue&type=style&index=0&id=f836c4c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f836c4c2",
  null
  
)

export default component.exports